var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('AppHeader'),_c('main',[_c('keep-alive',{attrs:{"exclude":"Achatticket"}},[_c('router-view')],1)],1),(!['achatticket', 'downloadTicket'].includes(this.$route.name))?_c('div',[_c('AppFooter')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }